module.exports = __webpack_public_path__ + "media/src/images/favicon-32x32-6f538df6182eb1d272c51b0bd0938742.png";